import actionTypes from 'message/actions/action-types';

export const clearSelectedMessagesList = () => ({
  type: actionTypes.CLEAR_SELECTED_MESSAGES_LIST,
});

export const setSelectAllPointerStatus = (hasAllMessagesSelected) => ({
  type: actionTypes.SET_SELECT_ALL_MESSAGES_POINTER,
  hasAllMessagesSelected,
});

export const addSelectedMessage = (selectedId) => ({
  type: actionTypes.ADD_MESSAGE_TO_SELECTED,
  selectedId,
});

export const removeSelectedMessage = (selectedId) => ({
  type: actionTypes.DELETE_MESSAGE_FROM_SELECTED,
  selectedId,
});

export const onMessageSelection = (selectedId) => (dispatch, getStore) => {
  const { messages } = getStore();
  const { selectedMessagesList } = messages.selectedMessages;

  const isAlreadySelected = selectedMessagesList.includes(selectedId);

  if (!isAlreadySelected) {
    dispatch(addSelectedMessage(selectedId));
  }

  if (isAlreadySelected) {
    dispatch(removeSelectedMessage(selectedId));
  }
};

export const toggleSelectAllMessagesPointer = (messagesList) => ({
  type: actionTypes.TOGGLE_SELECT_ALL_MESSAGES_POINTER,
  messagesList,
});



// WEBPACK FOOTER //
// ./src/modules/message/actions/selected-messages.actions.js